export default function map(array, func) {
    return array.reduce(function (result, el, i) {
        var val = func(el, i);
        if (val != null) {
            result.push(val);
        }
        return result;
    }, []);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@progress/kendo-ooxml/dist/es/utils/map.js
// module id = 491
// module chunks = 0